import React, { useContext } from "react";

import { MenuOwner } from "../../components/MenuOwner";
import { SectionTitle } from "../../components/SectionTitle";

import { NavbarContext } from "../../context/NavbarContext";

export const Owner = () => {  
  const { sideMinimize } = useContext(NavbarContext);

  return (
    <section className="bg-white flex">
      <div className={`${ sideMinimize ? "fill__section--minimize" : "fill__section" } hidden md:flex duration-700`}> 
      </div>

      <div className={`${ sideMinimize ? "container__section--minimize" : "container__section" } container__section--padding duration-700`}>
        <SectionTitle titleTop={"Creación de modelos basicos"} titleBottom={"Cliente"} />               
        <MenuOwner /> 
      </div>
    </section>
  )
}